const shouldLoadTreatments = ({ decisions, isCuratedCategory }) =>
  !!isCuratedCategory &&
  decisions?.["plp-curated-category-treatments"]?.bucket === "allSizes";

export default shouldLoadTreatments;
